import React, {useRef} from "react";
import { Button, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  browseButton: {
    backgroundColor: "#d9d9d9 !important",
    border: "1px solid #626262",
    color: "#626262 !important",
    padding: "7px 30px",
    fontWeight: "700",
    '&:hover': { backgroundColor: '#d9d9d9 !important', color: '#626262 !important' },
  }
});

interface FileUploadProps {
  name: string;
  label: string;
  control: any;
  errors: any;
  isDisabled: boolean;
  onFileChange: (file: File | undefined) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ name, label, control, errors, onFileChange , isDisabled = false }) => {
  const classes = useStyles();
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }: { field: any }) => (
        <>
          <Button variant="contained" component="label" sx={{ borderRadius: '30px', boxShadow: "0", px: 4, py: 1, textTransform: 'capitalize' }} className={classes.browseButton}>
            {label}
            <input 
              type="file" 
              hidden
              ref={fileInputRef}
              disabled={isDisabled}
              accept=".xls,.xlsx"
              onChange={(e) => {
                const file = e.target.files?.[0];
                field.onChange(file);
                onFileChange(file);
                // Reset input so same file can be selected again
                if (fileInputRef.current) {
                  fileInputRef.current.value = '';
                }
              }}
            />
          </Button>
          {errors[name] && <Typography color="error">{errors[name]?.message}</Typography>}
        </>
      )}
    />
  );
};

export default FileUpload;